import { render, staticRenderFns } from "./LoadingDetailEditor.vue?vue&type=template&id=4e60f1ad"
import script from "./LoadingDetailEditor.vue?vue&type=script&lang=js"
export * from "./LoadingDetailEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports